import {clsx} from 'clsx';
import React from 'react';
// @todo: Migrate to 'Link' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Link} from 'react-router-dom';

import * as S from './ArtifactSidebar.styles';
import {ArtifactMembershipSidebar} from './utils';

interface ArtifactVersionSidebarProps {
  isSelected: boolean;
  artifactMembership: ArtifactMembershipSidebar;
  to: string;
}

// Component to display Artifact Memberships
export const ArtifactVersionSidebar: React.FC<
  ArtifactVersionSidebarProps
> = props => {
  const versionIndex = props.artifactMembership.versionIndex;

  const aliases = props.artifactMembership.aliases.map(a => a.alias);
  const aliasesStrings = aliases.filter(t => t !== `v${versionIndex}`);
  return (
    <Link
      to={props.to}
      onClick={() =>
        window.analytics?.track('Artifact clicked', {versionIndex})
      }>
      <S.ArtifactItemString
        className={clsx('artifact-sidebar-item', 'version-option', {
          'selected-option': props.isSelected,
        })}>
        <div>
          <span data-cy="artifact-version">{`v${versionIndex}`}</span>
          {aliasesStrings.map(alias => (
            <S.AliasLabel data-cy="artifact-tag" key={alias}>
              {alias}
            </S.AliasLabel>
          ))}
        </div>
      </S.ArtifactItemString>
    </Link>
  );
};
